import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { useThemePreference, type ThemePreference } from '../lib/theme';

const OPTIONS: { value: ThemePreference; label: string; icon: LucideIcon }[] = [
  { value: 'system', label: 'System theme', icon: Monitor },
  { value: 'light', label: 'Light theme', icon: Sun },
  { value: 'dark', label: 'Dark theme', icon: Moon },
];

/** The System / Light / Dark choice in the top bar (JIRA-36). */
export function ThemeControl() {
  const [preference, setPreference] = useThemePreference();
  return (
    <div className="theme-control" role="group" aria-label="Theme">
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          aria-pressed={preference === value}
          aria-label={label}
          title={label}
          onClick={() => setPreference(value)}
        >
          <Icon size={14} aria-hidden />
        </button>
      ))}
    </div>
  );
}
